/**
 * Represents the major/minor values of a map product.
 */
export class ProductValues {
  /**
   * Gets the major value.
   */
  public major: number

  /**
   * Gets the minor value.
   */
  public minor: number

  /**
   * Initializes a new [ProductValues].
   * @param major The major value.
   * @param minor The minor value.
   */
  constructor(major: number, minor: number) {
    this.major = major
    this.minor = minor
  }
}
